import { cacheKeys } from "@constants/cache-keys";
import { TopicDetailView } from "@features/dashboard";
import useAppConfigIds from "@hooks/useAppConfigIds";
import type { MixedItemDistResponse } from "@memorang/types";
import { useQueryClient } from "@tanstack/react-query";
import { useLocalSearchParams } from "expo-router";

const DetailedListTopicsContainer = () => {
	const { type } = useLocalSearchParams<{
		type: string;
	}>();

	const { collectionId, userId } = useAppConfigIds();

	const queryClient = useQueryClient();
	const mixedItemDistResponse = queryClient.getQueryData<MixedItemDistResponse>(
		[cacheKeys.home, userId, collectionId],
	);

	if (!mixedItemDistResponse) {
		return null;
	}

	const { tags } = mixedItemDistResponse;
	return <TopicDetailView title={type!} tags={tags} />;
};

export default DetailedListTopicsContainer;
